import React from "react";
import "./SectorsSection.css";

const HouseingTrustSection = () => {
  const sectors = [
    "Corporate Offices",
    "IT Parks & Tech Centers",
    "Industrial Units",
    "Manufacturing Plants",
    "Banks & Financial Institutions",
    "Educational Institutions",
    "Hospitals & Clinics",
    "Retail Stores & Malls",
    "Hotels & Guest Houses",
    "Warehouses & Logistics",
    "Government Buildings",
    "Commercial Complexes"
  ];

  return (
    <section className="sector-section-wrapper">
      <div className="sector-section-container">
        <h2 className="sector-section-title">Trusted Across Sectors</h2>
        <p className="sector-section-subtitle">
          Serving diverse industries with excellence
        </p>

        <div className="sector-tags-wrapper">
          {sectors.map((sector, index) => (
            <span key={index} className="sector-tag">
              {sector}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HouseingTrustSection;
